export type ValidationType =
	| 'NUMBER'
	| 'INTEGERS'
	| 'STRING'
	| 'FIRSTNAME'
	| 'STREET'
	| 'LASTNAME'
	| 'HOUSENUMBER'
	| 'STREETANDHOUSENUMBER'
	| 'ZIP'
	| 'ZIP_GERMANY'
	| 'LOCATION'
	| 'PHONE'
	| 'EMAIL'
	| 'IBAN'
	| 'DATE'
	| 'DATE_FORMATTER'
	| 'SALUTATION';

const stringRegex = /.+/;

const regex: { [key in ValidationType]: RegExp } = {
	NUMBER: /^\d*\.?\d*$/,
	INTEGERS: /^[0-9]+$/,
	STRING: stringRegex,
	FIRSTNAME: stringRegex,
	LASTNAME: stringRegex,
	STREET: stringRegex,
	HOUSENUMBER: stringRegex,
	STREETANDHOUSENUMBER: stringRegex,
	IBAN: /^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z0-9]{4}\s?[0-9]{4}\s?[0-9]{3}([a-zA-Z0-9]\s?[a-zA-Z0-9]{0,4}\s?[a-zA-Z0-9]{0,4}\s?[a-zA-Z0-9]{0,4}\s?[a-zA-Z0-9]{0,3})?$/,
	ZIP_GERMANY: /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/,
	ZIP: stringRegex,
	LOCATION: stringRegex,
	PHONE: /^(?!049)([0]?[1-9][0-9]{1,14})$/,
	EMAIL: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/,
	SALUTATION: stringRegex,
	DATE: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
	DATE_FORMATTER: /^(\.|[0-9])[0-9]*(\.[0-9]+){0,2}(\.|[0-9])?$/,
};

const helperText: { [key in ValidationType]: string } = {
	NUMBER: 'Dieses Feld ist numerisch. Bitte geben Sie auschließlich Ziffern ein.',
	STRING: 'Dieses Feld darf nicht leer sein.',
	ZIP: 'Die Mindestlänge von 4 Zeichen wurde unterschritten.',
	ZIP_GERMANY: 'Bitte geben Sie genau 5 Ziffern in das Feld ein.',
	INTEGERS: 'Dieses Feld ist numerisch. Bitte geben Sie auschließlich Ziffern ein.',
	FIRSTNAME: 'Bitte geben Sie Ihren Vornamen ein.',
	LASTNAME: 'Bitte geben Sie Ihren Nachnamen ein. ',
	STREET: 'Bitte geben Sie Ihre Straße ein.',
	HOUSENUMBER: 'Bitte geben Sie Ihre Hausnummer ein.',
	STREETANDHOUSENUMBER: 'Bitte geben Sie Ihre Straße und Hausnummer ein.',
	LOCATION: 'Bitte geben Sie Ihren Wohnort ein.',
	PHONE: 'Bitte geben Sie Ihre Telefonnummer ohne Sonderzeichen ein, z.B.061712420100.',
	EMAIL: 'Bitte geben Sie eine gültige E-Mail-Adresse im Format abc@def.de ein.',
	IBAN: 'Bitte geben Sie eine gültige IBAN ein (mind. 16 Zeichen bis max. 31 Zeichen).',
	SALUTATION: 'Bitte geben Sie Ihre Anrede an.',
	DATE: 'Bitte geben Sie Ihr Datum im Format TT.MM.JJ ein.',
	DATE_FORMATTER: 'Bitte geben Sie Ihr Datum im Format TT.MM.JJ ein.',
};

export const checkValidation = (value: string, validationType: ValidationType) => !regex[validationType].test(value);

export const getHelperText = (validationType: ValidationType) => helperText[validationType];
